import { logger } from '@empathy/logger';

/**
 * Function to detect if the user has navigated from a PDP to the actual page through a back/forward browser action.
 * Sadly, some browsers don't support (yet, unknown when they will if they'll at all) the new Performance --> Navigation API and the
 * old API is deprecated and might be removed from any browser at any given time.
 *
 * @see For more information check: https://developer.mozilla.org/en-US/docs/Web/API/Performance/navigation
 */
export function hasUserNavigatedBackFromPDP(): boolean {
  if (window.performance) {
    const navEntries = window.performance.getEntriesByType('navigation');
    if (navEntries.length > 0 && navEntries[0].entryType === 'back_forward') {
      logger.info('Back/Forward detected using API2');
      return true;
    } else if (window.performance.navigation
      && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
      logger.info('Back/Forward detected using API1');
      return true;
    }
  } else {
    logger.warn('Browser does not support performance API');
  }

  return false;
}
